import React from "react";
import ChrTooltip from '../../../generic/Form/Basic/ChrTooltip';
import RatingBar from "./RatingBar";
import ChrLink from "../../../generic/Utils/ChrLink";

const LikertScaleChart = (props) => {
  const { ratings, headers, headerSubtext, shouldEnableLinks = true } = props;
  const { title, description, tooltip } = headers;
  const getUrl = obj => shouldEnableLinks ? obj.url : null;
  const headerUrl = getUrl(headers);

  return (
    <div className="d-flex flex-column flex-xs-row flex-md-column p-y-20 p-x-32">
      <div className="cui-flex-1 d-flex
        justify-content-start align-items-start
        justify-content-xs-center align-items-xs-center
        justify-content-md-start align-items-md-start
        pb-4
        pb-xs-0
        pb-md-4"
      >
        <div>
          <div className="font-20 font-600 d-flex cui-flex-gap-8 align-items-center">
            <ChrLink href={headerUrl} className='font-20 font-600 text-primary' newTab>
              {title}
            </ChrLink>
          </div>
          <div className="text-muted font-12 font-500">
            <span>{ description }</span>
            { tooltip &&
              <span className="inline">
                <ChrTooltip
                  content={ tooltip }
                  iconClass='fa-solid fa-circle-exclamation cui-caution-icon-color'
                />
              </span>
            }
          </div>
          { headerSubtext && <ChrLink href={shouldEnableLinks && headerSubtext.url} className='text-muted font-12 font-italic' newTab>
              {headerSubtext.text}
            </ChrLink>
          }
        </div>
      </div>

      <ul className="stat-list cui-flex-1 pb-3">
        {
          ratings.map(rating => {
            const ratingUrl = getUrl(rating);
            const imageProps = {
              width: 16,
              height: 16,
              alt: "",
              src: rating.image?.url,
              ...rating.image
            };
            return (
              <li key={rating.id} className="font-12 font-500">
                <div className="d-flex justify-content-between align-items-center">
                  <ChrLink href={ ratingUrl } className='text-muted' newTab>
                    <div className="d-flex justify-content-start cui-flex-gap-4 align-items-center">
                      { rating.image &&
                        <img { ...imageProps } />
                      }
                      { rating.label }
                    </div>
                  </ChrLink>
                  <div className="stat-percent">
                    <ChrLink href={ratingUrl} className='text-muted' newTab>
                      {rating.count}
                    </ChrLink>
                  </div>
                </div>
                <ChrLink href={ratingUrl} className='text-muted' newTab>
                  <RatingBar
                    percent={rating.percent}
                    color={rating.color}
                  />
                </ChrLink>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};

export default LikertScaleChart;
